module.exports = __webpack_public_path__ + "static/media/10.d99862dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/10.png
// module id = 1448
// module chunks = 0